import {ChangeDetectionStrategy, Component, Inject, Injectable, signal} from '@angular/core';

import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {AksjeeierEnkelModell, AksjeeierId, OppdaterBeholdningKommentarSpesifikasjon} from "../../../../../felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {AksjeeierDatatjeneste} from "felles-ng2/tjenester/datalager/AksjeeierDatatjeneste";
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatButtonModule} from "@angular/material/button";
import {MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {MatIconModule} from "@angular/material/icon";
import {MatToolbarModule} from "@angular/material/toolbar";
import {VisSpinnerDirektiv} from "web-ng2/delt/direktiver/button--visSpinner/button--visSpinner";
import {MatFormFieldModule} from "@angular/material/form-field";
import {DataOgMeta} from "felles-ng2/tjenester/datalager/DataOgMeta";
import {TranslateModule} from "@ngx-translate/core";
import {RiktekstRedigeringKomponent} from "web-ng2/delt/komponenter/skjema/riktekst-redigering/riktekst-redigering";

const debug = initDebugger('AksjeeierRedigerDialogKomponent');


@Component({
    selector: 'aksjeeier-rediger-dialog',
    templateUrl: './aksjeeier-rediger-beholdning-kommentar-dialog.html',
    styleUrls: ['./aksjeeier-rediger-beholdning-kommentar-dialog.scss'],
    imports: [
        FormsModule,
        MatButtonModule,
        MatDialogModule,
        MatIconModule,
        MatToolbarModule,
        VisSpinnerDirektiv,
        ReactiveFormsModule,
        TranslateModule,
        MatFormFieldModule,
        RiktekstRedigeringKomponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AksjeeierRedigerKommentarDialogKomponent {

    static vis(aksjeeier: Promise<AksjeeierEnkelModell>, dialog: MatDialog): MatDialogRef<AksjeeierRedigerKommentarDialogKomponent, void> {
        return dialog.open(AksjeeierRedigerKommentarDialogKomponent, {data: {aksjeeier: aksjeeier} as DialogParametre});
    }

    // Gitt at omfanget av skjemaet er lavt er skjemaet innlinet i dialogkomponenten.
    skjema = new FormGroup({
        kommentar:  new FormControl('', []) // todo - validering - hvor mye skal man egentlig kunne legge inn i kommentar? Ingen begrensninger i Sp2(?).
    });

    // Angis via aksjeeierid fra dialogparametere
    private id!:AksjeeierId;

    lagrer = signal(false);

    constructor(@Inject(MAT_DIALOG_DATA) parametre: DialogParametre,
                public dialogRef: MatDialogRef<AksjeeierRedigerKommentarDialogKomponent>,
                private avhengigheter: AksjeeierRedigerBeholdningKommentarDialogKomponentAvhengigheter) {
        debug("konstr", parametre)
        parametre.aksjeeier.then(aksjeeier => this.initSkjemaOgId(aksjeeier));
    }

    avbryt() {
        this.dialogRef.close();
    }

    lagre() {
        this.lagrer.set(true);
        this.avhengigheter.oppdaterKommentarPåNåværendeBeholdning(this.id, this.modellSomSpesifikasjon())
          .then(() => this.dialogRef.close())
          .finally(() => this.lagrer.set(false));
    }

    //private hjelpemetoder

    private initSkjemaOgId(aksjeeier: AksjeeierEnkelModell) {
        debug("initSkjema", aksjeeier)
        this.id = aksjeeier.id;
        this.skjema.patchValue({kommentar: aksjeeier.naavaerendeBeholdning?.kommentar});
    }

    private modellSomSpesifikasjon(): OppdaterBeholdningKommentarSpesifikasjon {
        return {kommentar: this.skjema.value.kommentar ?? ""};
    }
}

export interface DialogParametre {
    aksjeeier: Promise<AksjeeierEnkelModell>;
}

@Injectable()
export class AksjeeierRedigerBeholdningKommentarDialogKomponentAvhengigheter {

    constructor(private aksjeeierDatatjeneste: AksjeeierDatatjeneste) {
    }

    oppdaterKommentarPåNåværendeBeholdning(id: AksjeeierId, kommentar:OppdaterBeholdningKommentarSpesifikasjon ): Promise<DataOgMeta<AksjeeierEnkelModell>> {
        return this.aksjeeierDatatjeneste.oppdaterKommentarPåNåværendeBeholdning(id, kommentar)
    }
}
